var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M10.665 2.65667H12.1257V0.112667C11.8737 0.078 11.007 0 9.99767 0C7.89167 0 6.449 1.32467 6.449 3.75933V6H4.125V8.844H6.449V16H9.29833V8.84467H11.5283L11.8823 6.00067H9.29767V4.04133C9.29833 3.21933 9.51967 2.65667 10.665 2.65667Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

FacebookInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
